<template>
  <div class="flex flex-row items-center flex-wrap w-100 justify-center">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="flex flex-row justify-between"
    >
      <h5
        v-if="index > 0 && !setVertical"
        class="text-dark"
      >
        |
      </h5>
      <hr v-else-if="index > 0">
      <xn-nav-item
        class="mx-2"
        :value="item.value"
        :text="item.text"
      />
    </div>
  </div>
</template>
<script>
import XnNavItem from './XnNavItem.vue'
export default {
  name: 'XnNavBar',
  components: { XnNavItem },
  props: {
    items: {
      type: Array,
      default: () => {
        return [
          { text: 'Home', value: 'axoncollective.com' },
          { text: 'About', value: 'axoncollective.com' },
          { text: 'Contact', value: 'axoncollective.com' },
        ]
      },
    },
    setVertical: { type: Boolean, default: false },
    useDivider: { type: Boolean, default: true },
  },
}
</script>
<style scoped></style>
